<app-modal
  #modal
  [modalConfig]="{
    titleText: 'Edit Competency',
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    customFooter: true,
    closeOnBgClick: true,
    options: {
      size: 'lg',
    },
  }"
  (isDismissing)="closeModal()">
  <button
    [disabled]="isUpdating"
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="closeModal()">
    <i class="bi bi-x-lg text-white"></i>
  </button>

  <ng-container *ngIf="competency && competencyForm && modal.isOpen">
    <form [formGroup]="competencyForm">
      <div class="form-group">
        <input
          formControlName="title"
          aria-label="Competency Title"
          placeholder="Enter Competency Name"
          class="form-control competency-input mb-3"
          id="title"
          name="title"
          required />
      </div>

      <div class="levels-wrapper">
        <div class="level-item">
          <div class="level-header">
            <label for="level1" class="level-name">{{ levelNames[0] }}</label>
          </div>
          <div class="level-content">
            <textarea
              formControlName="level1"
              placeholder="Enter content"
              class="form-control title-input"
              name="description"
              aria-label="Description"
              rows="7"
              [ngClass]="{
                'is-invalid': formSubmitted && f['level1'].errors
              }"></textarea>
          </div>
        </div>
        <div class="level-item">
          <div class="level-header">
            <label for="level2" class="level-name">{{ levelNames[1] }}</label>
          </div>
          <div class="level-content">
            <textarea
              formControlName="level2"
              placeholder="Enter content"
              class="form-control title-input"
              name="description"
              aria-label="Description"
              rows="7"
              [ngClass]="{
                'is-invalid': formSubmitted && f['level2'].errors
              }"></textarea>
          </div>
        </div>
        <div class="level-item" *ngIf="competency.gis.length >= 3">
          <div class="level-header">
            <label for="level3" class="level-name">{{ levelNames[2] }}</label>
          </div>
          <div class="level-content">
            <textarea
              formControlName="level3"
              placeholder="Enter content"
              class="form-control title-input"
              name="description"
              aria-label="Description"
              rows="7"
              [ngClass]="{
                'is-invalid': formSubmitted && f['level3'].errors
              }"></textarea>
          </div>
        </div>
        <div class="level-item" *ngIf="competency.gis.length >= 4">
          <div class="level-header">
            <label for="level4" class="level-name">{{ levelNames[3] }}</label>
          </div>
          <div class="level-content">
            <textarea
              formControlName="level4"
              placeholder="Enter content"
              class="form-control title-input"
              name="description"
              aria-label="Description"
              rows="7"
              [ngClass]="{
                'is-invalid': formSubmitted && f['level4'].errors
              }"></textarea>
          </div>
        </div>
        <div class="level-item" *ngIf="competency.gis.length >= 5">
          <div class="level-header">
            <label for="level5" class="level-name">{{ levelNames[4] }}</label>
          </div>
          <div class="level-content">
            <textarea
              formControlName="level5"
              placeholder="Enter content"
              class="form-control title-input"
              name="description"
              aria-label="Description"
              rows="7"
              [ngClass]="{
                'is-invalid': formSubmitted && f['level5'].errors
              }"></textarea>
          </div>
        </div>
      </div>
    </form>
  </ng-container>

  <div footerContent>
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <ng-container *ngIf="canDeleteCompetency">
          <button
            aria-label="delete competency button"
            class="btn btn-txt-delete me-2"
            type="button"
            [autoClose]="'outside'"
            [ngbPopover]="deleteContent"
            [popoverTitle]="'Delete Competency'"
            [autoClose]="'outside'"
            #popover="ngbPopover">
            Delete
          </button>
          <ng-template #deleteContent>
            Are you sure you want to delete this competency?
            <div class="text-end mt-2">
              <button
                type="button"
                class="btn btn-secondary btn-sm px-3 m-1"
                (click)="popover.close()">
                No
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm px-3 m-1"
                (click)="handleDelete(); popover.close()">
                Yes
              </button>
            </div>
          </ng-template>
        </ng-container>
      </div>
      <button
        [disabled]="isUpdating"
        type="submit"
        class="btn btn-md btn-primary"
        (click)="onSubmit()">
        <span
          *ngIf="isUpdating"
          class="spinner-border spinner-border-sm me-1"></span
        >Update
      </button>
    </div>
  </div>
</app-modal>
